import styled from "styled-components";
import { Image, inlineMediaQueryMixin } from "@zillow/constellation";
const GroupBackgroundImage = styled(Image).withConfig({
  displayName: "GroupBackgroundImage",
  componentId: "sc-19vtin-0"
})(["&&&{pointer-events:none;position:absolute;top:0;right:0;bottom:0;left:0;", " width:100%;height:100%;", " ", "}"], inlineMediaQueryMixin("backgroundSize", (mediaProps) => `object-fit: ${mediaProps.backgroundSize};`), inlineMediaQueryMixin("backgroundPosition", (mediaProps) => `object-position: ${mediaProps.backgroundPosition};`), inlineMediaQueryMixin("backgroundImageVisible", (mediaProps) => mediaProps.backgroundImageVisible ? "display: initial;" : "display: none;"));
GroupBackgroundImage.defaultProps = {
  backgroundPosition: "50% 50%",
  backgroundSize: {
    default: "cover"
  }
};
export {
  GroupBackgroundImage as default
};
